import { IOnInit, IPromise } from "angular";
import {
  FormViewController,
  FormViewService,
  vsServiceName as FormViewServiceName,
} from "../../../../../../records/forms/formView";
import fieldHelpers from "../../../../../../ui-formly/fieldHelpers";
import { StateService } from "@uirouter/angularjs";
import { Machine } from "../../../../models/machine";
import { IFieldArray } from "AngularFormly";
import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../../../../records/forms/formly/fieldConfigurationHelpers";
import { vsLookupManagementServiceName as machineLookupManagementServiceName } from "../../../../../shared/lookups";
import { LookupManagementService } from "../../../../../../records/lookup/lookupManagement";
import { warehouseTypeName } from "../../../../configs/lookup";
import {
  ChangeJournalModalService,
  vsServiceName as ChangeJournalModalServiceName,
} from "../../../../../../records/changeJournal/changeNoteModalService";

export class SingleMachineWarehouseComponentController implements IOnInit {
  static $inject = [
    FormViewServiceName,
    "$state",
    FieldConfigurationHelperServiceName,
    machineLookupManagementServiceName,
    ChangeJournalModalServiceName,
  ];
  readonly formFields: IFieldArray;
  model: any;
  /* start bindings */
  readonly machine!: Machine;
  /* end binding */

  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService,
    fieldConfigurationHelperService: FieldConfigurationHelperService,
    machineLookupManagementService: LookupManagementService,
    private readonly changeJournalModalService: ChangeJournalModalService
  ) {
    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleDateField({
            key: "Date",
            name: "Date",
            label: "Change Date",
            required: true,
          }),
          fieldConfigurationHelperService.lookupField(
            machineLookupManagementService,
            {
              key: "MachineWarehouseTypeId",
              label: "Warehouse Type",
              objectName: warehouseTypeName,
            }
          ),
        ],
        4
      ),
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleStringField({
            key: "WarehouseLocation",
            name: "WarehouseLocation",
            label: "Warehouse Location",
          }),
          /* TODO - add client specific warehouse fields here */
        ],
        4
      ),
      {
        key: "Files",
        name: "Files",
        type: "recordFileUpload",
        templateOptions: {
          allowMultiple: true,
          label: "Compliance Files",
          group: "Compliance",
        },
      },
      {
        key: "Files",
        name: "Files",
        type: "recordFileUpload",
        templateOptions: {
          allowMultiple: true,
          label: "Software Compliance Notices",
          group: "SoftwareCompliance",
        },
      },
      {
        key: "Files",
        name: "Files",
        type: "recordFileUpload",
        templateOptions: {
          allowMultiple: true,
          label: "Internal Documentation",
          group: "InternalDocumentation",
        },
      },
      {
        key: "Files",
        name: "Files",
        type: "recordFileUpload",
        templateOptions: {
          allowMultiple: true,
          label: "Machine PAR Sheets",
          group: "MachineParSheets",
        },
      },
      fieldHelpers.headerField({
        headerText: "Notes",
        key: "NotesHeader",
      }),
      fieldHelpers.textAreaField({
        key: "Notes",
        name: "Notes",
        label: " ",
        rows: 5,
      }),
    ];
  }

  $onInit(): void {
    const currentConfiguration = this.machine.Configs?.find(
      (c) => c.CurrentConfiguration
    );
    this.model = {
      MachineId: this.machine.Id,
      Files: currentConfiguration?.Files?.map((f: any) => {
        return {
          Name: f.Name,
          ContentType: f.ContentType,
          Url: f.Url,
          Group: f.Group,
        };
      }),
    };
  }

  submit(formViewController: FormViewController): IPromise<void> {
    const machineId = this.machine.Id;
    return this.changeJournalModalService
      .getAndSetChangeJournalNote(this.model)
      .then(() => {
        return this.formViewService.submitForm({
          url: `/api/machines/${machineId}/warehouse`,
          formObject: this.model,
          formViewController,
          method: "post",
        });
      })
      .then(() => {
        return this.$state.go("^", undefined, { reload: true });
      })
      .then(() => {});
  }

  cancel(): Promise<void> {
    return this.$state.go("^").then(() => {});
  }
}
